import { CalendarClock } from 'lucide-react'
import { cn } from '@/utils/cn'
import type { DealMeetingSchedule } from './kanbanCardV2Utils'

export function meetingRelativeClass(tone: DealMeetingSchedule['tone']) {
  const isPast = tone === 'past'
  const isNow = tone === 'now'

  return cn(
    'inline-flex max-w-full items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold capitalize',
    isPast
      ? 'border-warning/25 bg-warning/10 text-warning'
      : isNow
        ? 'border-accent/30 bg-accent/12 text-accent'
        : 'border-accent/15 bg-accent/[0.06] text-text-secondary',
  )
}

export function KanbanCardMeetingRelative({ meeting }: { meeting: DealMeetingSchedule }) {
  const label = meeting.relative ?? 'Reunião agendada'

  return (
    <span className={meetingRelativeClass(meeting.tone)} title={label}>
      <CalendarClock size={10} strokeWidth={2} aria-hidden />
      <span className='truncate'>{label}</span>
    </span>
  )
}

export function KanbanCardMeetingChip({ meeting }: { meeting: DealMeetingSchedule }) {
  const isPast = meeting.tone === 'past'
  const isNow = meeting.tone === 'now'

  return (
    <div
      className={cn(
        'deals-v2-meeting-chip flex min-w-0 flex-1 items-center gap-2.5 rounded-lg border px-2.5 py-2',
        isPast
          ? 'border-warning/25 bg-warning/[0.06]'
          : isNow
            ? 'border-accent/35 bg-accent/[0.1]'
            : 'border-accent/20 bg-accent/[0.05]',
      )}
    >
      <span
        className={cn(
          'flex h-8 w-8 shrink-0 items-center justify-center rounded-lg',
          isPast ? 'bg-warning/10 text-warning' : 'bg-accent/12 text-accent',
        )}
      >
        <CalendarClock size={14} strokeWidth={2} aria-hidden />
      </span>

      <div className='min-w-0 flex-1 leading-tight'>
        <div className='flex min-w-0 items-center gap-2'>
          <span className='truncate text-[11px] font-semibold tabular-nums text-text-primary'>
            {meeting.date}
          </span>
          <span
            className={cn(
              'shrink-0 rounded-md px-1.5 py-0.5 text-[10px] font-bold tabular-nums tracking-wide',
              isPast ? 'bg-warning/15 text-warning' : 'bg-accent/15 text-accent',
            )}
          >
            {meeting.time}
          </span>
        </div>
      </div>
    </div>
  )
}

export function KanbanCardNextStepChip({ label }: { label: string }) {
  return (
    <div className='flex min-w-0 flex-1 items-center gap-2 rounded-lg border border-[var(--border)] bg-[var(--bg-dark)] px-2.5 py-2'>
      <span className='flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-white/[0.04] text-text-muted'>
        <CalendarClock size={12} strokeWidth={2} aria-hidden />
      </span>
      <p className='truncate text-[10px] font-medium text-text-secondary'>{label}</p>
    </div>
  )
}
